import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ControlBase } from './models/control-base';
import { ControlService } from './services/control.service';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-generic-form',
  templateUrl: './generic-form.component.html',
  styleUrls: ['./generic-form.component.css'],
  providers: [ ControlService ]
})
export class GenericFormComponent implements OnInit {
  @Input() controls: ControlBase<string>[] | null = [];
  @Input() form: UntypedFormGroup;
  @Output() payload = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {
  }

  onSubmit() {
    this.payload.emit(JSON.stringify(this.form.getRawValue()));
  }
}
